import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/svg/quiz/quiz-availability-stage-meetings-clustered.svg?data'
import _imports_1 from '@/assets/images/svg/quiz/quiz-availability-stage-meetings-spread.svg?data'


const _hoisted_1 = { class: "grid grid-equalize" }
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Continue ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuizSelectableButton = _resolveComponent("QuizSelectableButton")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_QuizCard = _resolveComponent("QuizCard")!

  return (_openBlock(), _createBlock(_component_QuizCard, {
    title: "Meetings, arranged?",
    description: "Meeting fatigue? Some like it back-to-back. Are you a sucker for pain or do you prefer to have breaks in between?",
    "onQuizNavigation:back": _ctx.navigatePrev,
    "onQuizNavigation:close": _cache[2] || (_cache[2] = ($event: any) => (_ctx.QuizService.close())),
    class: "quiz-availability-stage-meetings-arrangement",
    "is-vertically-aligned": true,
    prev: !_ctx.QuizService.editing.value
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_AppButton, {
        disabled: _ctx.selectedArrangement === '' || _ctx.QuizService.isSaving(),
        loading: _ctx.QuizService.isSaving(),
        onClick: _ctx.navigateNext
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["disabled", "loading", "onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_QuizSelectableButton, {
            title: _ctx.MEETING_ARRANGEMENTS.CLUSTERED,
            selected: _ctx.selectedArrangement === _ctx.MEETING_ARRANGEMENTS.CLUSTERED,
            size: "small",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedArrangement = _ctx.MEETING_ARRANGEMENTS.CLUSTERED)),
            class: "quiz-availability-stage-meetings-arrangement__button"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["title", "selected"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_QuizSelectableButton, {
            title: _ctx.MEETING_ARRANGEMENTS.SPREAD,
            selected: _ctx.selectedArrangement === _ctx.MEETING_ARRANGEMENTS.SPREAD,
            size: "small",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedArrangement = _ctx.MEETING_ARRANGEMENTS.SPREAD)),
            class: "quiz-availability-stage-meetings-arrangement__button"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["title", "selected"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onQuizNavigation:back", "prev"]))
}